import { createContext, useContext } from 'react';

interface CardLoadingContextType {
  setLoading: (isLoading: boolean) => void;
}

export const CardLoadingContext = createContext<CardLoadingContextType | null>(null);

export const useCardLoading = () => {
  const context = useContext(CardLoadingContext);
  if (!context) {
    throw new Error('useCardLoading must be used within a LoadingCard');
  }
  return context;
};